import Model, { attr } from '@ember-data/model';

export default class TagRecord extends Model {
	@attr('string') name!: string;
	@attr('string') color!: string;
	@attr('number') createdBy!: number | null;
}
